// Use X and Y to index into arrays that represent coordinate pairs.
// e.g. point[X]
export const X = 0;
export const Y = 1;
